import { Toast } from 'widgets';

import { useCreateTask, useCreateTaskForTenant } from '../task-queries';
import { TaskFormOutput } from '../widgets/TaskForm';

const taskCreatedMessage = (title: string) => `Task "${(title || 'Untitled Task').slice(0, 20)}" created successfully`;

// The one place TaskForm output turns into create requests: tenant-only, one task per selected
// household, or a single household. Resolves to true when everything was created so the caller
// can close its dock item or sheet.
export const useSubmitTaskForm = () => {
    const createTask = useCreateTask();
    const createTaskForTenant = useCreateTaskForTenant();
    const isPending = createTask.isPending || createTaskForTenant.isPending;

    const submit = async (data: TaskFormOutput): Promise<boolean> => {
        if (isPending) return false;
        try {
            if ('noHousehold' in data) {
                await createTaskForTenant.mutateAsync(data);
                Toast.success(taskCreatedMessage(data.title));
            } else if ('householdGuids' in data) {
                const { householdGuids, ...base } = data;
                await Promise.all(
                    householdGuids.map((householdGuid) => createTask.mutateAsync({ ...base, householdGuid })),
                );
                Toast.success(
                    `${householdGuids.length} task${householdGuids.length > 1 ? 's' : ''} created successfully`,
                );
            } else {
                await createTask.mutateAsync(data);
                Toast.success(taskCreatedMessage(data.title));
            }
            return true;
        } catch (e) {
            Toast.forError(e, 'Failed to create task(s)');
            return false;
        }
    };

    return { submit };
};
